import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function DiagnosisSection() {
  const problems = [{
    id: '01',
    title: 'El cliente de Moving necesita confiar, no solo comparar precios.',
    body: 'Está entregando todas sus posesiones a desconocidos. Si tu presencia digital no proyecta confianza absoluta en los primeros 5 segundos, llama al siguiente de la lista.'
  }, {
    id: '02',
    title: 'Sin sistema de depósito previo, los No-Show te cuestan miles al mes.',
    body: 'Camiones, empleados y gasolina para una mudanza que el cliente canceló sin avisar. Un sistema de reserva con depósito automático elimina ese problema.'
  }, {
    id: '03',
    title: 'El verano no puede ser tu única temporada.',
    body: 'Hay mudanzas de empresas, mudanzas de apartamentos, mudanzas de largo recorrido. Todo el año. En todas las épocas. Solo necesitas el sistema para encontrarlos.'
  }];
  return <section className="w-full py-20 md:py-24 px-6 flex justify-center bg-carbon" data-id="element-87">
      <div className="max-w-5xl w-full" data-id="element-88">
        <motion.h2 className="text-gold text-3xl sm:text-4xl lg:text-5xl font-bold mb-16 text-center md:text-left max-w-4xl leading-tight" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-89">
          Por qué el Moving es el negocio donde más dinero se pierde por falta
          de sistema.
        </motion.h2>

        <motion.div className="flex flex-col gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-90">
          {problems.map(problem => <motion.div key={problem.id} variants={cardVariants} className="bg-surface border border-border p-8 md:p-10 rounded-xl flex flex-col md:flex-row gap-6 md:gap-10 items-start" data-id="element-91">
              <span className="text-gold text-4xl md:text-5xl font-black font-mono leading-none opacity-80" data-id="element-92">
                {problem.id}
              </span>
              <div data-id="element-93">
                <h3 className="text-light text-xl md:text-2xl font-bold mb-3" data-id="element-94">
                  {problem.title}
                </h3>
                <p className="text-muted text-lg leading-relaxed" data-id="element-95">
                  {problem.body}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}